module.exports = __webpack_public_path__ + "static/media/FoodBG.ba70e8a5.svg";